import { ExclamationTriangleIcon, ArrowLeftIcon, ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import workInProgressImage from "../../assets/salon-bg.jpg";

export default function WorkInProgress() {
  return (
    <div
      className="relative h-[92vh] flex items-center justify-center bg-cover bg-center bg-black bg-opacity-40"
      style={{ backgroundImage: `url(${workInProgressImage})` }}
    >
      {/* Overlay pour améliorer la lisibilité */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/30 backdrop-blur-md"></div>

      {/* ✅ BOX CONTENANT LE TEXTE & LES BOUTONS */}
      <div className="relative bg-white bg-opacity-95 backdrop-blur-lg shadow-2xl border border-gray-300 rounded-2xl p-8 max-w-lg text-center animate-fade-in transition-all duration-300">
        
        {/* ✅ ICÔNE D'ALERTE */}
        <ExclamationTriangleIcon className="w-14 h-14 text-[#b8860b] mx-auto mb-4 animate-bounce" />

        <h2 className="text-lg font-semibold text-gray-700">En cours de construction</h2>
        <h1 className="text-4xl font-extrabold text-[#003366] mt-2 drop-shadow-md">Work in Progress...</h1>

        <p className="text-gray-600 mt-4 leading-relaxed">
          Cette page est actuellement en cours de développement.<br />
          Revenez plus tard pour découvrir les nouveautés !
        </p>

        {/* ✅ BOUTONS */}
        <div className="flex justify-center gap-4 mt-8">
          <a
            href="/dashboard"
            className="flex items-center gap-2 bg-[#003366] hover:bg-[#002855] text-white font-semibold py-2 px-5 rounded-lg transition-transform transform hover:scale-105 shadow-md"
          >
            <ArrowLeftIcon className="w-5 h-5" />
            Retour au Dashboard
          </a>

          <a
            href="/support"
            className="flex items-center gap-2 border border-[#003366] text-[#003366] hover:bg-[#003366] hover:text-white font-semibold py-2 px-5 rounded-lg transition-transform transform hover:scale-105 shadow-md"
          >
            <ChatBubbleLeftRightIcon className="w-5 h-5" />
            Contacter le support
          </a>
        </div>
      </div>
    </div>
  );
}
